<a class="btn btn-success m-btn m-btn--custom m-btn--icon" (click)="showModal()">
  <span>
    {{ 'bank-new.addBank' | transloco }}
  </span>
</a>

<ng-template #templateRef let-modal>
  <div class="modal-header">
    <h3 class="modal-title" *ngIf="!isEdit">{{ 'bank-new.addBank' | transloco }}</h3>
    <h3 class="modal-title" *ngIf="isEdit">{{ 'bank-new.bankEditing' | transloco }}</h3>
    <button class="close" type="button" (click)="modal.dismiss()">
      <span>×</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="isLoading.form">
    <div class="m-page-loader m-page-loader--non-block m-page-loader--relative">
      <div class="m-loader m-loader--brand"></div>
    </div>
  </div>

  <div class="modal-body" *ngIf="!isLoading.form">
    <form class="m-form m-form--state m-form--label-align-right" [formGroup]="bankForm" (ngSubmit)="onSubmitForm(modal)">
      <div class="m-portlet__body" *ngIf="bankForm">
        <div class="m-form__section m-form__section--first m-form--label-align-right">
          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
              {{ 'bank-new.bankName' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <input type="text" formControlName="name" class="form-control m-input" placeholder="">
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12 is--required">
              {{ 'bank-new.bic' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <input type="text" formControlName="bic" [readonly]="id" class="form-control m-input" placeholder="">
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
              {{ 'bank-new.bicBefore' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <input type="text" formControlName="oldBic" class="form-control m-input" placeholder="">
            </div>
          </div>


          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-md-4 col-sm-12">
              {{ 'bank-new.address' | transloco }}:
            </label>
            <div class="col-lg-8 col-md-8 col-sm-12">
              <input type="text" formControlName="address" class="form-control m-input" placeholder="">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer modal-footer--pad-right">
        <button type="submit" class="btn btn-success">
          {{ 'btn.save' | transloco }}
        </button>

        <button type="button" (click)="closeModal(modal)" class="btn btn-secondary">
          {{ 'btn.cancel' | transloco }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
